import axios from 'axios';
import config from './config';

// The public Tools page catalog (cellcog.ai/tools, Nov 3 2026). PUBLIC endpoint: no auth interceptor, the page is read signed
// out. Backend: py/cellcog/api/public_tools_catalog.py (cached server-side, rate-limited per IP).
const publicToolsApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
  timeout: 15000,
});

/** { total, categories: [{ id, count, showcase: [slug] }], apps: [{ slug, name, logo_url, categories: [bucket id] }] } */
export const getPublicToolsCatalog = () => publicToolsApi.get('/public/tools/catalog');

export default publicToolsApi;
